import { StyleRules } from '@material-ui/core/styles';
import { MenuItemClassKey } from '@material-ui/core/MenuItem';

import { core as theme } from '../styles/core';

export const MuiMenuItem: Partial<StyleRules<MenuItemClassKey>> = {
  root: {
    ...theme.typography.body2,
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    '&.Mui-selected': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.lightest,
      '&:hover': {
        backgroundColor: theme.palette.primary.lightest,
      },
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.lighter,
      color: theme.palette.primary.dark,
    },
  },
};
